import { render, staticRenderFns } from "./FeaturedIconTile.vue?vue&type=template&id=004e66c6&scoped=true"
import script from "./FeaturedIconTile.vue?vue&type=script&lang=js"
export * from "./FeaturedIconTile.vue?vue&type=script&lang=js"
import style0 from "./FeaturedIconTile.vue?vue&type=style&index=0&id=004e66c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e66c6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedIconTile.vue
// module id = 223
// module chunks = 0